<template>
  <div>
    <div align="left">
      <el-date-picker
        v-model="date"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="选择日期">
      </el-date-picker>


      <el-button type="primary" icon="el-icon-circle-plus" @click="getTSHistory" >查询</el-button>

    </div>


    <el-table
      :data="tableData"
      border
      style="width: 100%"
      max-height="100%">
      <el-table-column
        fixed
        prop="hospital"
        label="医疗企业"
        width="300">
      </el-table-column>
      <el-table-column
        prop="time"
        label="时间"
        width="140">
      </el-table-column>

      <el-table-column
        prop="infectious_num"
        label="感染性(箱)"
        width="90">
      </el-table-column>
      <el-table-column
        prop="infectious_weight"
        label="感染性(kg)"
        width="90">
      </el-table-column>
      <el-table-column
        prop="injure_num"
        label="损伤性(箱)"
        width="90">
      </el-table-column>
      <el-table-column
        prop="injure_weight"
        label="损伤性(kg)"
        width="90">
      </el-table-column>
      <el-table-column
        prop="box"
        label="周转箱"
        width="65">
      </el-table-column>
      <el-table-column
        prop="bag"
        label="塑料袋"
        width="65">
      </el-table-column>
      <el-table-column
        prop="sharps_box"
        label="利器盒"
        width="65">
      </el-table-column>
      <el-table-column
        prop="driver"
        label="司机"
        width="70">
      </el-table-column>
      <el-table-column
        prop="car_id"
        label="车牌号"
        width="100">
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="220">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="print(scope.$index, tableData)"
            type="primary"
            size="mini">
            打印
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10,20,50,100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <el-dialog title="增加新转运联单" width="800px" :visible.sync="dialogFormVisible">
      <el-form :model="form" align="left">
        <el-form-item label="医疗企业编号" :label-width="formLabelWidth">
          <el-select v-model="form.hospital" filterable placeholder="请选择医疗企业编号" style="width: 350px">
            <el-option
              v-for="item in hospitals"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间" :label-width="formLabelWidth">
          <el-date-picker
            v-model="form.time"
            type="datetime"
            placeholder="请选择时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="感染性" :label-width="formLabelWidth">
          数量 <el-input-number v-model="form.infectious_num" style="width: 220px" :min="0" :precision="0" :step="1" :controls="false" ></el-input-number>
          重量 <el-input-number v-model="form.infectious_weight" style="width: 220px" :min="0"  :controls="false"></el-input-number>
        </el-form-item>
        <el-form-item label="损伤性" :label-width="formLabelWidth">
          数量 <el-input-number v-model="form.injure_num" style="width: 220px" :min="0" :precision="0" :step="1" :controls="false" ></el-input-number>
          重量 <el-input-number v-model="form.injure_weight" style="width: 220px" :min="0"  :controls="false">></el-input-number>
        </el-form-item>
        <el-form-item label="周转箱" :label-width="formLabelWidth" >
          <el-input-number v-model="form.box" autocomplete="off" style="width: 220px" :min="0" :precision="0" :step="1" :controls="false"></el-input-number>
        </el-form-item>
        <el-form-item label="塑料袋" :label-width="formLabelWidth">
          <el-input-number v-model="form.bag" autocomplete="off" style="width: 220px" :min="0" :precision="0" :step="1" :controls="false"></el-input-number>
        </el-form-item>
        <el-form-item label="利器盒" :label-width="formLabelWidth">
          <el-input-number v-model="form.sharps_box" autocomplete="off" style="width: 220px" :min="0" :precision="0" :step="1" :controls="false"></el-input-number>
        </el-form-item>
        <!--<el-form-item label="车牌号" :label-width="formLabelWidth">-->
        <!--<el-select v-model="form.car_id" filterable placeholder="请选择">-->
        <!--<el-option-->
        <!--v-for="item in car_id_options"-->
        <!--:key="item.value"-->
        <!--:label="item.label"-->
        <!--:value="item.value">-->
        <!--</el-option>-->
        <!--</el-select>-->
        <!--</el-form-item>-->
        <el-form-item label="司机" :label-width="formLabelWidth">
          <el-select v-model="form.driver" filterable placeholder="请选择司机">
            <el-option
              v-for="item in driver_options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="create">添 加</el-button>
      </div>
    </el-dialog>



    <el-dialog title="修改转运联单" width="800px" :visible.sync="modifyFormVisible">
      <el-form :model="form_modify" align="left">
        <el-form-item label="医疗企业" :label-width="formLabelWidth">
          <el-select v-model="form_modify.hospital" filterable placeholder="请选择医疗企业" style="width: 350px">
            <el-option
              v-for="item in hospitals"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间" :label-width="formLabelWidth">
          <el-date-picker
            v-model="form_modify.time"
            type="datetime"
            placeholder="请选择时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="感染性" :label-width="formLabelWidth">
          数量 <el-input-number v-model="form_modify.infectious_num" style="width: 220px" :min="0" :precision="0" :step="1" :controls="false"></el-input-number>
          重量 <el-input-number v-model="form_modify.infectious_weight" style="width: 220px" :min="0"  :controls="false"></el-input-number>
        </el-form-item>
        <el-form-item label="损伤性" :label-width="formLabelWidth">
          数量 <el-input-number v-model="form_modify.injure_num" style="width: 220px" :min="0" :precision="0" :step="1" :controls="false" ></el-input-number>
          重量 <el-input-number v-model="form_modify.injure_weight" style="width: 220px" :min="0"  :controls="false" ></el-input-number>
        </el-form-item>
        <el-form-item label="周转箱" :label-width="formLabelWidth">
          <el-input-number v-model="form_modify.box" autocomplete="off" style="width: 220px" :min="0" :precision="0" :step="1" :controls="false"></el-input-number>
        </el-form-item>
        <el-form-item label="塑料袋" :label-width="formLabelWidth">
          <el-input-number v-model="form_modify.bag" autocomplete="off" style="width: 220px" :min="0" :precision="0" :step="1" :controls="false"></el-input-number>
        </el-form-item>
        <el-form-item label="利器盒" :label-width="formLabelWidth">
          <el-input-number v-model="form_modify.sharps_box" autocomplete="off" style="width: 220px" :min="0" :precision="0" :step="1" :controls="false"></el-input-number>
        </el-form-item>
        <!--<el-form-item label="车牌号" :label-width="formLabelWidth">-->
        <!--<el-select v-model="form_modify.car_id" filterable placeholder="请选择">-->
        <!--<el-option-->
        <!--v-for="item in car_id_options"-->
        <!--:key="item.value"-->
        <!--:label="item.label"-->
        <!--:value="item.value">-->
        <!--</el-option>-->
        <!--</el-select>-->
        <!--</el-form-item>-->
        <el-form-item label="司机" :label-width="formLabelWidth">
          <el-select v-model="form_modify.driver" filterable placeholder="请选择司机">
            <el-option
              v-for="item in driver_options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="modifyFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="modify">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import coder from "./enum.js"
import Config from "./config.js"
export default {
  methods: {
    showDialog(e){
      this.form={
        hospital:'',
        time:'',
        infectious_num:0,
        infectious_weight:0,
        injure_num:0,
        injure_weight:0,
        box:0,
        bag:0,
        sharps_box:0,
        car_id:'',
        driver:'',
      };
      this.dialogFormVisible=true;
    },
    getTSHistory(){
      //if(this.isTerminal){
        window.ws.Call("W2S_TSList2", this.date, this.driver, this.page, this.pageSize);
      // }else {
      //   window.ws.Call("W2S_TSList", this.date, this.driver, this.page, this.pageSize);
      // }
    },
    modify(){
      if (this.form_modify.hospital==""){
        this.$alert('医疗企业不能为空，错误！', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      if (this.form_modify.driver==""){
        this.$alert('司机不能为空，错误！', '错误', {
          confirmButtonText: '确定'
        });
        return
      }

      let $this=this;
      window.ws.AddFunc("S2W_ModifyTSRes",function (code,errStr) {
        if (code===coder.OK) {
          $this.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success'
          });
          $this.modifyFormVisible=false;
          window.ws.Call("W2S_TSList",$this.date,$this.driver,$this.page,$this.pageSize);
        }else{
          $this.$alert(err+'('+code+')', '错误', {
            confirmButtonText: '确定'
          });
        }

      });
      window.ws.Call("W2S_ModifyTS",
        parseInt(this.form_modify.id),
        this.form_modify.hospital,
        $this.dateFormat("YYYY-mm-dd HH:MM",this.form_modify.time),
        parseInt(this.form_modify.infectious_num),
        parseFloat(this.form_modify.infectious_weight),
        parseInt(this.form_modify.injure_num),
        parseFloat(this.form_modify.injure_weight),
        parseInt(this.form_modify.box),
        parseInt(this.form_modify.sharps_box),
        parseInt(this.form_modify.bag),
        this.form_modify.driver)
    },
    dateFormat(fmt, date) {
      let ret;
      const opt = {
        "Y+": date.getFullYear().toString(),        // 年
        "m+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "H+": date.getHours().toString(),           // 时
        "M+": date.getMinutes().toString(),         // 分
        "S+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        };
      };
      return fmt;
    },
    create(){
      let $this=this;
      console.log("createUser:",this.form);
      if (this.form.hospital==""){
        this.$alert('医疗企业不能为空，错误！', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      if (this.form.driver==""){
        this.$alert('司机不能为空，错误！', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      window.ws.AddFunc("S2W_AddTSRes",function (code,err) {
        if (code===coder.OK) {
          $this.$notify({
            title: '成功',
            message: '添加成功',
            type: 'success'
          });
          $this.dialogFormVisible=false;
          window.ws.Call("W2S_TSList",$this.date,$this.driver,$this.page,$this.pageSize);
        }else{
          $this.$alert(err+'('+code+')', '错误', {
            confirmButtonText: '确定'
          });
        }
      });
      window.ws.Call("W2S_AddTS",
        this.form.hospital,
        $this.dateFormat("YYYY-mm-dd HH:MM",this.form.time),
        parseInt(this.form.infectious_num),
        parseFloat(this.form.infectious_weight)*1000,
        parseInt(this.form.injure_num),
        parseFloat(this.form.injure_weight)*1000,
        parseInt(this.form.box),
        parseInt(this.form.sharps_box),
        parseInt(this.form.bag),
        this.form.driver)
    },
    delTS(index,rows){
      let $this=this;
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        window.ws.AddFunc("S2W_DelTSRes",function (code,err) {
          if (code===coder.OK) {
            $this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success'
            });
            $this.modifyFormVisible=false;
            window.ws.Call("W2S_TSList",$this.date,$this.driver,$this.page,$this.pageSize);
          }else{
            $this.$alert(err+'('+code+')', '错误', {
              confirmButtonText: '确定'
            });
          }
        });
        window.ws.Call("W2S_DelTS",rows[index].id);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    print(index,rows) {
      window.open(Config.HTTP+"transportPrint?id="+rows[index].id, '_blank');
    },
    showModify(index,rows){
      this.form_modify.id=rows[index].id;
      this.form_modify.hospital=rows[index].hospital;
      this.form_modify.time=new Date(Date.parse(rows[index].time.replace(/-/g,   "/")));
      this.form_modify.infectious_num=rows[index].infectious_num;
      this.form_modify.infectious_weight=rows[index].infectious_weight;
      this.form_modify.injure_num=rows[index].injure_num;
      this.form_modify.injure_weight=rows[index].injure_weight;
      this.form_modify.box=rows[index].box;
      this.form_modify.bag=rows[index].bag;
      this.form_modify.sharps_box=rows[index].sharps_box;
      this.form_modify.car_id=rows[index].car_id;
      this.form_modify.driver=rows[index].driver;
      this.modifyFormVisible=true;
    },
    handleSizeChange(e){
      this.pageSize=e;
      window.ws.Call("W2S_TSList",this.date,this.driver,this.page,this.pageSize);
    },
    handleCurrentChange(e){
      this.page=e;
      window.ws.Call("W2S_TSList",this.date,this.driver,this.page,this.pageSize);
    }
  },
  mounted() {
    let $this=this;
    console.log("###Page loaded !");

    window.ws.AddFunc("S2W_CarAndLineAndDriverRes",function(code,err,cars,lines,drivers){
      if (code===coder.OK) {
        let carIDs = [];
        for(let i=0;i<cars.length;i++){
          carIDs.push({value:cars[i],label:cars[i]})
        }
        $this.car_id_options=carIDs;
        // $this.setData({car_id_options:carIDs});

        let lineArr = [];
        for(let i=0;i<lines.length;i++){
          lineArr.push({value:lines[i],label:lines[i]})
        }
        $this.line_options = lineArr;
        // $this.setData({line_options :lineArr});

        let driverArr = [];
        for(let i=0;i<drivers.length;i++){
          driverArr.push({value:drivers[i],label:drivers[i]})
        }
        $this.driver_options = driverArr
        // $this.setData({driver_options:driverArr});
      }else{
        $this.$alert(err+'('+code+')', '错误', {
          confirmButtonText: '确定'
        });
      }
    });
    window.ws.Call("W2S_CarAndLineAndDriver");
    if (window.hospitals===null||window.hospitals==undefined||window.hospitals.length===0) {
      window.ws.AddFunc("S2W_GetHospitalNamesRes",function(list){
        let names = [];
        for(let i=0;i<list.length;i++){
          names.push({value:list[i],label:list[i]})
        }
        $this.hospitals=names;
        window.hospitals=names;
      });
      console.log("W2S_GetHospitalNames");
      window.ws.Call("W2S_GetHospitalNames");
    }else{
      //console.log("HospitalCodes:::",window.hospitals);
      this.hospitals=window.hospitals
    }
    window.ws.AddFunc("S2W_TSListRes",function (code,err,currentPage,total,list) {
      console.log("S2W_TSListRes:",code,err,currentPage,total,list)
      if (code==coder.OK){
        $this.page=currentPage;
        $this.total=total;
        $this.tableData=list;
      }
    });
    this.date=this.dateFormat("YYYY-mm-dd",new Date());
    window.ws.Call("W2S_TSList",$this.date,$this.driver,$this.page,$this.pageSize);




  },
  data() {
    return {
      form: {
        hospital:'',
        time:'',
        infectious_num:0,
        infectious_weight:0,
        injure_num:0,
        injure_weight:0,
        box:0,
        bag:0,
        sharps_box:0,
        car_id:'',
        driver:'',
      },
      form_modify:{
        id:0,
        hospital:'',
        time:'',
        infectious_num:0,
        infectious_weight:0.00,
        injure_num:0,
        injure_weight:0.00,
        box:0,
        bag:0,
        sharps_box:0,
        car_id:'',
        driver:'',
      },
      dialogFormVisible:false,
      modifyFormVisible:false,
      formLabelWidth: '120px',
      isTerminal:false,
      page:1,
      pageSize:10,
      total:0,
      tableData: [],
      date:'',
      driver:'',
      car_id_options: [],
      line_options:[],
      driver_options: [],
      hospitals:[],
      hospitalCodes:[],
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/MyTransshipmentSheet.vue